import { render } from "./MaterialsWithoutAgreement.vue?vue&type=template&id=5d7ce950&scoped=true"
import script from "./MaterialsWithoutAgreement.vue?vue&type=script&lang=js"
export * from "./MaterialsWithoutAgreement.vue?vue&type=script&lang=js"

import "./MaterialsWithoutAgreement.vue?vue&type=style&index=0&id=5d7ce950&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7ce950"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
